/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface UpdateTuitionRateTierResponse
 */
export interface UpdateTuitionRateTierResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof UpdateTuitionRateTierResponse
     */
    id: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the UpdateTuitionRateTierResponse interface.
 */
export function instanceOfUpdateTuitionRateTierResponse(value: object): value is UpdateTuitionRateTierResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UpdateTuitionRateTierResponseFromJSON(json: any): UpdateTuitionRateTierResponse {
    return UpdateTuitionRateTierResponseFromJSONTyped(json, false);
}

export function UpdateTuitionRateTierResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTuitionRateTierResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
    };
}

export function UpdateTuitionRateTierResponseToJSON(json: any): UpdateTuitionRateTierResponse {
    return UpdateTuitionRateTierResponseToJSONTyped(json, false);
}

export function UpdateTuitionRateTierResponseToJSONTyped(value?: UpdateTuitionRateTierResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
    };
}

